module.exports = __webpack_public_path__ + "img/guanlihoutai.d0fa31fa.png";